import React from "react";
import cx from "classnames";
import { Link } from "gatsby";
import { Image } from "src/components/image";
import { useSiteContext } from "src/context/siteContext";

import * as styles from "./footer.module.css";

interface RelatedProject {
	_id: string;
	content: {
		main: {
			title: string;
			slug: {
				current: string;
			};
			indexThumbnail: {
				asset: {
					_id: string;
				};
			};
		};
	};
}
interface ProjectFooterProps {
	data: {
		nextProject: RelatedProject;
		previousProject: RelatedProject;
		relatedProjects: { edges: [{ node: RelatedProject }] };
		primaryTag: string;
	};
}
export const ProjectFooter = ({ data }: ProjectFooterProps) => {
	const { nextProject, previousProject, relatedProjects, primaryTag } = data;

	return (
		<div className={styles.footer}>
			<div className={styles.previousNext}>
				<div>
					{previousProject && (
						<Link
							to={`/work/${previousProject.content.main.slug.current}`}
							className={cx(styles.previousNextLink, styles.previousLink)}
						>
							<span>
								Previous Project
								<br />
								{previousProject.content.main.title}
							</span>
							<div className={styles.previousNextImageContainer}>
								<Image
									className={styles.previousNextImage}
									gatsbyImageClassName={styles.previousNextGatsbyImage}
									alt={previousProject.content.main.title}
									imageId={
										previousProject.content.main.indexThumbnail.asset._id
									}
									width={84}
								/>
							</div>
						</Link>
					)}
				</div>
				<div>
					{nextProject && (
						<Link
							to={`/work/${nextProject.content.main.slug.current}`}
							className={cx("ar", styles.previousNextLink, styles.nextLink)}
						>
							<span>
								Next Project
								<br />
								{nextProject.content.main.title}
							</span>
							<div className={styles.previousNextImageContainer}>
								<Image
									className={styles.previousNextImage}
									gatsbyImageClassName={styles.previousNextGatsbyImage}
									alt={nextProject.content.main.title}
									imageId={nextProject.content.main.indexThumbnail.asset._id}
									width={84}
								/>
							</div>
						</Link>
					)}
				</div>
			</div>
			{relatedProjects.edges?.length > 0 && (
				<div className={styles.relatedProjects}>
					More in {primaryTag}.{" "}
					<Link to="/work">
						<em>
							<span className="underline-on-hover">View All.</span>
						</em>
					</Link>
					<div className={styles.relatedProjectsRow}>
						{relatedProjects.edges.map((edge) => {
							return (
								<div
									className={styles.relatedProjectCard}
									key={edge.node.content.main.slug.current}
								>
									<Link
										to={`/work/${edge.node.content.main.slug.current}`}
										className={cx(styles.relatedProjectCardLink)}
									>
										<div className={styles.relatedProjectCardImageContainer}>
											<Image
												className={styles.relatedProjectCardImage}
												alt={edge.node.content.main.title}
												imageId={
													edge.node.content.main.indexThumbnail.asset._id
												}
												width={84}
												gatsbyImageClassName={
													styles.relatedProjectCardGatsbyImage
												}
											/>
										</div>
										<span
											className={cx("label", styles.relatedProjectCardTitle)}
										>
											{edge.node.content.main.title}
										</span>
									</Link>
								</div>
							);
						})}
					</div>
				</div>
			)}
		</div>
	);
};

// ProjectCard.whyDidYouRender = true;
